<template>
  <DBox
    :id="'cmp-distribution-suppliers-sidewindow-catalogue_list'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="'Add New Catalogue'"
    @addClick="onAddClick"
    :searchButton="true"
    :searchFlag="searchFlag"
    :badgeButtons="
      filterExists
        ? [
            {
              text: $t('reset_filters'),
              value: 'reset_filters',
              icon: 'delete-white',
            },
          ]
        : []
    "
    @badgeClick="onBadgeClick"
    @searchClick="onSearchClick"
  >
    <div v-if="searchFlag" class="ut-flex ut-jbetween">
      <div class="search-controls ut-flex">
        <InputField
          :value="searchString"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'bottom',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
        <Dropdown
          :options="release_monthsTV"
          :selected="
            release_monthsTV.find((e) => e.value == searchModel.release_month)
          "
          :placeholder="'Select Period'"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onFilterSelected('release_month', e)"
          :style="{
            width: '178px',
          }"
        ></Dropdown>
      </div>
      <button @click="onApplyFilter" class="dt-button dt-button v5 s8 m8">
        {{$t('apply_filter')}}
      </button>
    </div>
    <div
      class="ut-fh"
      :style="{
        height: this.searchFlag ? `calc(100% - 52px)` : undefined,
      }"
    >
      <NTable
        id="distribution-suppliers-sidewindow-catalogue_list"
        class="h1 dbox1"
        :config="tableConfig"
        :headers="headers"
        :items="list"
        :showNoItems="false"
      >
        <template v-slot:thead="{ thcon, thtext }">
          <tr>
            <th
              v-for="header in headers"
              v-bind="thcon(header.value)"
              :key="header.value"
            >
              <div v-if="header.value == 'barcode'" class="header-name">
                <div>
                  {{ $t("catalog_no") }}
                </div>
                <div>
                  {{ $t("barcode") }}
                </div>
              </div>
              <div v-else-if="header.value == 'artist'" class="header-name">
                <div>
                  {{ $t("artist") }}
                </div>
                <div>
                  {{ $t("title") }}
                </div>
              </div>
              <div
                style="text-align: end"
                v-else-if="header.value == 'initialQty'"
                class="header-name"
              >
                <div>
                  {{ $dft.capHead($t("initial_qty")) }}
                </div>
                <div>
                  {{ $t("min_stock") }}
                </div>
              </div>
              <div v-else class="header-name">
                {{ thtext(header.value) }}
              </div>
            </th>
          </tr>
        </template>
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('label_name')">
              <span class="txtov" :title="item['label']">
                {{ item["label"] }}
              </span>
            </td>
            <td v-bind="tdcon('release_date')">
              <span class="txtov" :title="item['release_date']">
                {{ item["release_date"] }}
              </span>
            </td>
            <td v-bind="tdcon('barcode')">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-start;
                "
              >
                <span
                  @click="onSelectedProduct(item)"
                  class="txtov ut-link ut-text-accent5"
                >
                  {{ item["catalog_no"] }}</span
                >
                <span  @click="onSelectedProduct(item)"
                  class="txtov ut-link ut-text-accent5">{{ item["barcode"] }}</span>
              </div>
            </td>
            <td v-bind="tdcon('artist')">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-start;
                "
              >
                <span class="txtov">{{ item["artist"] }}</span>
                <span class="txtov"> {{ item["title"] }}</span>
              </div>
            </td>

            <td v-bind="tdcon('format')">
              <span class="txtov" :title="item['format']">
                {{ item["format"] }}
              </span>
            </td>
            <td v-bind="tdcon('cost_price')">
              <div class="cost_price">
                <TextField2
                  :ta="'right'"
                  :id="'cost_price'"
                  :showLabel="false"
                  :bb="'0px'"
                  style="width: 90px"
                  :disabled="item['disabled']"
                  :value="item['cost_price']"
                  @blur="(e) => onTextFieldValueChange(e, item)"
                />
                <span class="txtov">
                  {{ $store.getters.account.client.default_currency }}
                </span>
              </div>
            </td>
            <td v-bind="tdcon('initialQty')">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-start;
                "
              >
                <TextField2
                  :ta="'right'"
                  :id="'initial_qty'"
                  :showLabel="false"
                  :bb="'0px'"
                  :disabled="item['disabled']"
                  :value="item['initial_qty']"
                  @blur="(e) => onTextFieldValueChange(e, item)"
                />
                <TextField2
                  :ta="'right'"
                  :id="'min_stock'"
                  :bb="'0px'"
                  :showLabel="false"
                  :disabled="item['disabled']"
                  :value="item['min_stock']"
                  @blur="(e) => onTextFieldValueChange(e, item)"
                />
              </div>
            </td>
            <td v-bind="tdcon('type')">
              <Dropdown2
                class="dbox1"
                :showLabel="false"
                :disabled="item['disabled']"
                :options="product_TypesTV"
                :selected="
                  product_TypesTV.find((e) => e.value == item.product_type_id)
                "
                :placeholder="$t('type')"
                v-on:selectedChange="
                  (e) => onDropdownChange('product_type_id', e, item)
                "
                :bb="'0px'"
              />
            </td>
            <td v-bind="tdcon('options')">
              <img
                src="static/icons/delete.svg"
                @click.stop="(e) => onCatalogueDelete(item)"
                class="dt-icon v5 s2"
                alt
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>

<!-- <template>
  <DBox
    :id="'cmp-distribution-suppliers-sidewindow-catalogue_list'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="'Add New Catalogue'"
    @addClick="onAddClick"
  >
    <NTable
      id="distribution-suppliers-sidewindow-catalogue_list"
      class="h1 dbox1"
      :config="tableConfig"
      :headers="headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('label_name')">
            <span class="txtov ut-link ut-text-accent5" :title="item['label']">
              {{ item["label"] }}
            </span>
          </td>
          <td v-bind="tdcon('release_date')">
            <span class="txtov" :title="item['release_date']">
              {{ item["release_date"] }}
            </span>
          </td>
          <td v-bind="tdcon('barcode')">
            <span class="txtov" :title="item['barcode']">
              <span> {{ item["catalog_no"] }}</span>
              <span> {{ item["barcode"] }}</span>
            </span>
          </td>
          <td v-bind="tdcon('artist')">
            <span class="txtov" :title="item['title']">
              {{ item["title"] }} {{ item["artist"] }}
            </span>
          </td>

          <td v-bind="tdcon('type')">
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :disabled="item['disabled']"
              :options="product_TypesTV"
              :selected="
                product_TypesTV.find((e) => e.value == item.product_type_id)
              "
              :placeholder="$t('type')"
              v-on:selectedChange="
                (e) => onDropdownChange('product_type_id', e, item)
              "
              :bb="'0px'"
            />
          </td>
          <td v-bind="tdcon('cost_price')">
            <div class="cost_price">
              <TextField2
                :ta="'right'"
                :id="'cost_price'"
                :showLabel="false"
                style="width: 100px"
                :disabled="item['disabled']"
                :value="item['cost_price']"
                @blur="(e) => onTextFieldValueChange(e, item)"
              />
              <span class="txtov">
                {{ $store.getters.account.client.default_currency }}
              </span>
            </div>
          </td>

          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="(e) => onCatalogueDelete(item)"
              class="dt-icon v5 s2"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template> -->

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { openWindow } from "../../../../utility";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { distributionSupplierActions } from "../../store/suppliers/actions";
import { SuppliersService } from "../../services/suppliers.service";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { DTIconButton } from "../../../../plugins/button/button";
import { productsListLDTRoutes } from "../../../catalog/router/routes";
export default {
  components: {
    DBox,
    NTable,
    DTIconButton,
  },
  props: ["selectedSupplierDetails"],
  data: function () {
    return {
      searchFlag: false,
      searchModel: {
        search: "",
        release_month: "",
      },
      searchString: "",
      searchSubject$: new Subject(),
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        rowHeight: 62,
        headerHeight: 48,
      }),
    };
  },
  computed: {
    filterExists() {
      return this.searchModel.search || this.searchModel.release_month;
    },
    list: function () {
      return this.selectedSupplierDetails.products || [];
    },
    product_TypesTV: function () {
      return this.selectedSupplierDetails.product_TypesTV || [];
    },
    release_monthsTV: function () {
      return this.selectedSupplierDetails.release_monthsTV || [];
    },
    headers: function () {
      return [
        createTableHeader("label_name"),
        createTableHeader("release_date"),
        createTableHeader("barcode", {
          text: `${this.$t("barcode")} / ${this.$t("catalog_no")}`,
          minw: 150,
        }),
        createTableHeader("artist", {
          text: `${this.$t("artist")} / ${this.$t("title")}`,
          minw: 200,
        }),
        createTableHeader("format", { mw: 60 }),
        createTableHeader("cost_price", { ta: "right", minw: 120 }),
        createTableHeader("initialQty", {
          text: `${this.$t("initial_qty")}/ ${this.$t("min_stock")}`,
          minw: 120,
          ta: "right",
        }),
        createTableHeader("type"),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
  },
  mounted() {
    this.$subscribeTo(
      this.searchSubject$
        .asObservable()
        .pipe(debounceTime(500), distinctUntilChanged()),
      (searchString) => {
        this.searchModel = {
          ...this.searchModel,
          search: searchString,
        };
        this.searchString = searchString;
        this.onApplyFilter();
      }
    );
  },
  methods: {
    ...mapActionObject(storeNS, distributionSupplierActions),
    onAddClick: function () {
      this.$emit("add_click", "add_catalogue_form");
    },
    onCatalogueDelete: async function (item) {
      const confirmationResult = await confirmDelete(
        "Catalogue",
        item.catalog_no
      );
      if (confirmationResult === "OK") {
        const res1 = await SuppliersService.removeSupplierProducts({
          ...item,
        });

        const products = this.selectedSupplierDetails?.products.filter(
          (b) => b.product_id !== item.product_id
        );
        this[ActionTypes.DistributionSupplierCatalogue.SET.ALL]({
          supplier_id: this.selectedSupplierDetails?.supplier?.supplier_id,
          products: [...products] || [],
        });
      }
    },
    onTextFieldValueChange: function ({ name, value }, item) {
      this.$emit("changed", {
        name,
        value,
        kVal: item.product_id,
        table: "l_products",
      });
      this.updateData(item);
    },
    onSelectedProduct: function (item) {
      this.$router.push({
        name: productsListLDTRoutes.names.tab,
        params: {
          product_id: item.product_id,
          tab: "overview",
        },
      });
    },
    onDropdownChange: function (name, value, item) {
      item[name] = value.value;
      this.$emit("changed", {
        name,
        value: value.value,
        kVal: item.product_id,
        table: "l_products",
      });
      this.updateData(item);
    },
    onStatementWindow: function (item) {
      openWindow(item.stmt_link, "_blank", { wr: 0.7, hr: 0.7 });
    },
    onSearchClick: function () {
      this.searchFlag = !this.searchFlag;
      this.$emit("showSearchFlag", this.searchFlag);
    },
    onBadgeClick(badge) {
      if (badge == "reset_filters") {
        this.searchString = "";
        this.searchModel = {
          search: "",
          release_month: "",
        };
        this.$emit("search", {});
        this.onApplyFilter();
        this.searchFlag = false;
        this.$emit("showSearchFlag", this.searchFlag);
      }
    },
    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
      this.searchModel = {
        ...this.searchModel,
        search: this.searchString,
      };
      this.searchSubject$.next(event.target.value);
    },
    onFilterSelected: function (name, value) {
      this.searchModel[name] = value.value;
      this.onApplyFilter();
    },
    async onApplyFilter() {
      const result = await SuppliersService.loadFilterSupplierProducts({
        supplier_id: this.selectedSupplierDetails?.supplier?.supplier_id,
        ...this.searchModel,
      });
      this[ActionTypes.DistributionSupplierCatalogue.SET.ALL]({
        supplier_id: this.selectedSupplierDetails?.supplier?.supplier_id,
        products: result.data.products || [],
      });
    },
    updateData: function (item) {
      const products = this.selectedSupplierDetails.products.map((b) => {
        if (b.product_id === item.product_id) {
          b = {
            ...item,
          };
        }
        return b;
      });

      this[ActionTypes.DistributionSupplierCatalogue.SET.ALL]({
        supplier_id: this.selectedSupplierDetails?.supplier?.supplier_id,
        products: products || [],
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-suppliers-sidewindow-catalogue_list {
  .search-controls {
    .input-field-container {
      margin: 10px;
    }
    .dropdown {
      margin: 10px;
    }
  }
  .link {
    padding-top: 10px;
  }
  .cost_price {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}
</style>
